import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { NgbDateStruct, NgbCalendar, NgbDatepickerConfig, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../services/toast.service';
 
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['../../app.component.scss', './register.component.scss', '../auth.scss','../login/login.component.scss'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}],
  encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit {
  model: NgbDateStruct;
  slides = [
    { 
      image: 'assets/images/carousel/image-1.jpg', 
      title: 'Welcome to Assign Solutions', 
      description: 'Discover new ideas every day!' 
    },
    { 
      image: 'assets/images/carousel/image-2.jpg', 
      title: 'Your Interests Matter', 
      description: 'Save what you love, discover what you like.' 
    },
    { 
      image: 'assets/images/carousel/image-3.jpg', 
      title: 'Explore & Create', 
      description: 'Find inspirations and share your creativity!' 
    }
  ];
  currentIndex = 0;
  intervalId: any;
  // countryCodes = [
  //   { name: "India", code: "+91" },
  //   { name: "UK", code: "+44" },
  //   { name: "USA", code: "+1" },
  // ];

  countryCodes = [
    {
      id: 1,
      name: "India",
      code: "+91",
      flagClass: 'in',
    },
    {
      id: 2,
      name: "United States",
      code: "+1",
      flagClass: 'us',
    },
    {
      id: 3,
      name: "United Kingdom",
      code: "+44",
      flagClass: 'uk',
    },
    {
      id: 4,
      name: "Canada",
      code: "+1",
      flagClass: 'ca',
    },
    {
      id: 5,
      name: "Spain",
      code: "+34",
      flagClass: 'es',
    },
    {
      id: 6,
      name: "Israel",
      code: "+972",
      flagClass: 'il',
    },
  ]

  stateCodes = [
  { name: 'Mumnai', code: '+022' },
  { name: 'New Delhi', code: '+011' },
  { name: 'Bangalore', code: '+080' },
  { name: 'Kolkata', code: '+033' },
  { name: 'Chennai', code: '+044' },
  { name: 'Hyderabas', code: '+040' },
  { name: 'Pune', code: '+020' },
  { name: 'Ahmedabad', code: '+079' },
  // Add more states as needed
  ];

  selectedStateCode = '';

  extensionText = "+91";
  registerForm: FormGroup;
  genderData: any[] = ['MALE', 'FEMALE', 'OTHER'];
  url: any = 'https://s3.ap-south-1.amazonaws.com/cloudbizerp1554798177/avatar-1577909_1280.png';

  constructor(
    public toastService: ToastService,
    private fb: FormBuilder,
    private _auth: AuthService,
    private _router: Router,
    config: NgbDatepickerConfig,
    calendar: NgbCalendar,
  ) {
    config.minDate = { year: 1900, month: 1, day: 1 };
    config.maxDate = { year: new Date().getFullYear(), month: 12, day: 31 };
    config.outsideDays = 'hidden';
  }

  ngOnInit() {
    this.registerForm = this.fb.group({
      salutation: [''],
      f_name: [
        "",
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(1),
        ],
      ],
      l_name: [
        "",
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(1),
        ],
      ],
      organization_name: [''],
      username: [''],
      email_addresses: this.fb.array([]),
      mobile_numbers: this.fb.array([]),
      landline_numbers: this.fb.array([]),
      password: [
        "",
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(8),
        ],
      ],
      c_password: [
        "",
        [
          Validators.required,
          Validators.maxLength(40),
          Validators.minLength(8),
        ],
      ],
      gender: [''],
      dob: [''],
      terms: [false]
    });

    this.addEmailField();
    this.addMobileField();
    this.addLandlineField();
    this.startAutoSlide();

     // Listen for changes in the salutation field
     const salutationControl = this.registerForm.get('salutation');
     if (salutationControl) {
       salutationControl.valueChanges.subscribe((salutation: string) => {
         if (salutation === 'MR') {
           this.registerForm.patchValue({ gender: 'MALE' });
         } else if (salutation === 'MISS' || salutation === 'MRS') {
           this.registerForm.patchValue({ gender: 'FEMALE' });
         } else {
           this.registerForm.patchValue({ gender: '' }); // Clear gender if no valid salutation is selected
         }
       });
     }
  }

  

  initEmailAddress() {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  initMobileNumber() {
    return this.fb.group({
      isd: [this.countryCodes.find(country => country.code === '+91')], // Default to India (+91)
      mobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  initLandlineNumber() {
    return this.fb.group({
      isd: [this.countryCodes.find(country => country.code === '+91')], // Default to India (+91)
      std: [''],
      landline: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  addEmailField() {
    const control = <FormArray>this.registerForm.controls['email_addresses'];
    control.push(this.initEmailAddress());
  }

  removeEmailField(index: number) {
    const control = <FormArray>this.registerForm.controls['email_addresses'];
    control.removeAt(index);
  }

  addMobileField() {
    const control = <FormArray>this.registerForm.controls['mobile_numbers'];
    control.push(this.initMobileNumber());
  }

  removeMobileField(index: number) {
    const control = <FormArray>this.registerForm.controls['mobile_numbers'];
    control.removeAt(index);
  }

  addLandlineField() {
    const control = <FormArray>this.registerForm.controls['landline_numbers'];
    control.push(this.initLandlineNumber());
  }

  removeLandlineField(index: number) {
    const control = <FormArray>this.registerForm.controls['landline_numbers'];
    control.removeAt(index);
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 8000); // Change every 8 seconds
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  

  registerUser() {
    // if (this.registerForm.invalid) {
    //   return;
    // }

    let registerFormData = this.registerForm.value;
    registerFormData.landline_numbers = registerFormData.landline_numbers.map((landline: any) => {
      return {
        isd: landline.isd.code,
        std: landline.std,
        landline: landline.landline
      }
    });
    registerFormData.mobile_numbers = registerFormData.mobile_numbers.map((mobile: any) => {
      return {
        isd: mobile.isd.code,
        mobile: mobile.mobile
      }
    });

    this._auth.registerUser(registerFormData)
      .subscribe(
        res => {
          localStorage.setItem('token', res.token);
          this._router.navigate(['/auth/employee/login'], { queryParams: { redirectUrl: 'http://localhost:4300/helpdesk/settings/user/user-directory', sourceUrl: 'http://localhost:4300' } });
          this.showSuccess('Registration successfully');
        },
        error => {
          if (error.status == 0) {
            this.showDanger('We are experiencing some issues, Please try after sometime!');
          } else {
            console.log(error.error);
            const errorData = error.error;
            let counter = 0;
            for (const key in errorData) {
              if (errorData.hasOwnProperty(key)) {
                if (counter > 2) {
                  break;
                }
                const val = errorData[key];
                this.showDanger(val);
                counter++;
              }
            }
          }
        }
      );
  }

  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (event) => {
        this.url = reader.result;
        console.log(event);
      };
    }
  }

  findUser() {
    this._auth.availableUser(this.registerForm.value)
      .subscribe(
        res => {
        },
        error => {
          if (error.status === 0) {
          } else if (error.status === 409) {
          } else {
            console.log(error.error);
            const errorData = error.error;
            for (const key in errorData) {
              if (errorData.hasOwnProperty(key)) {
                const val = errorData[key];
              }
            }
          }
        }
      );
  }


  onISDSelect(countryCode: string, index: string | number) {
    this.extensionText = countryCode;
    (this.registerForm.controls["mobile_numbers"] as FormArray).controls[index]
      .get("isd")
      .setValue(countryCode);
    (this.registerForm.controls["landline_numbers"] as FormArray).controls[index]
      .get("isd")
      .setValue(countryCode);
  }
  
  onStateCodeSelect(code: string, index: number) {
    (this.registerForm.controls["landline_numbers"] as FormArray).controls[index].get('stateCode').setValue(code);
    this.selectedStateCode = code;
  }

  resetUser() {
    if (confirm("Are you sure you want to reset the form?")) {
      this.registerForm.reset();
      this.url = 'https://s3.ap-south-1.amazonaws.com/cloudbizerp1554798177/avatar-1577909_1280.png';
      this.selectedStateCode = '';
      this.extensionText = "+91";

      // Reset form arrays
      const emailControl = <FormArray>this.registerForm.controls['email_addresses'];
      while (emailControl.length !== 0) {
        emailControl.removeAt(0);
      }
      this.addEmailField();

      const mobileControl = <FormArray>this.registerForm.controls['mobile_numbers'];
      while (mobileControl.length !== 0) {
        mobileControl.removeAt(0);
      }
      this.addMobileField();

      const landlineControl = <FormArray>this.registerForm.controls['landline_numbers'];
      while (landlineControl.length !== 0) {
        landlineControl.removeAt(0);
      }
      this.addLandlineField();
    }
  }

  showSuccess(successMessage) {
    //this.tagsInput.nativeElement.focus();
    this.toastService.show(successMessage, { classname: 'bg-success text-light', delay: 10000, autohide: true });
  }

  showDanger(dangerTpl) {
    this.toastService.show(dangerTpl, { classname: 'bg-danger text-light', delay: 15000, autohide: true });
  }

}
